// SPDX-License-Identifier: GPL-3.0-or-later

export const interviewTemplate = String.raw`#set page(paper: "a4", margin: 2cm)
#set text(font: "Libertinus Serif", size: 11pt)
#show heading.where(level: 1): it => {
  block(below: 6pt)[
    #upper(text(weight: "bold", size: 12pt)[#it.body])
    #line(length: 100%, stroke: 0.5pt)
  ]
}
#set list(indent: 1em, spacing: 4pt)

#align(center)[
  #text(size: 18pt, weight: "bold")[Interview prep] \
  _{{interviewer.name}}{{#interviewer.role}}, {{interviewer.role}}{{/interviewer.role}} #sym.dot.c {{interviewType}}_
]

#v(0.8em)

= Likely topics

{{#likelyTopics}}
*{{topic}}*

{{#sampleQuestions}}
- {{.}}
{{/sampleQuestions}}
{{/likelyTopics}}

= Questions to ask them

{{#yourQuestions}}
- {{.}}
{{/yourQuestions}}

= Talking points about the company

{{#companyTalkingPoints}}
- {{.}}
{{/companyTalkingPoints}}

{{#recentNews}}
= Recent news (verify before citing)

{{#recentNews}}
- {{.}}
{{/recentNews}}
{{/recentNews}}
`;
